module.exports = __webpack_public_path__ + "img/97.ef33fff0.jpg";